import { RumErrorEvent, datadogRum } from '@datadog/browser-rum';
import { isBotUserAgent, isE2ESession, isFeatureEnabled } from 'common/utils';

import { getDatadogProxy } from './datadogProxy';

export const initDatadogRum = () => {
  // Don't initialize Datadog in E2E test sessions, if bot detected, or if feature is disabled
  if (isE2ESession() || isBotUserAgent() || !isFeatureEnabled('DatadogEnabled')) {
    return;
  }

  datadogRum.init({
    applicationId: '0e7b150d-d0c4-4736-a9c2-3eb1cfd0b8ff',
    clientToken: window._env_.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'natter-frontend',
    env: window._env_.VITE_APP_ENVIRONMENT,
    version: window._env_.VITE_APP_TAG,
    // Same-origin intake proxy (telemetry-relay via CloudFront /ddintake/*), gated by DatadogProxyEnabled.
    // undefined when the flag is off → SDK posts directly to Datadog.
    proxy: getDatadogProxy(),
    sessionSampleRate: window._env_.DATADOG_SESSION_SAMPLE_RATE
      ? Number(window._env_.DATADOG_SESSION_SAMPLE_RATE)
      : 100,
    sessionReplaySampleRate: window._env_.DATADOG_SESSION_REPLAY_SAMPLE_RATE
      ? Number(window._env_.DATADOG_SESSION_REPLAY_SAMPLE_RATE)
      : 100,
    defaultPrivacyLevel: 'mask-user-input',
    // Link RUM resources to backend APM traces; matches the api./dev-api. host on every env (excludes auth-api, natalie, third parties).
    allowedTracingUrls: [
      {
        // Anchored both ends: SDK matches via unanchored RegExp.test, so without ^ + host-boundary look-alike hosts would leak trace headers.
        match: /^https:\/\/(api|dev-api)\.([a-z0-9-]+\.)*natter\.(co|network)(?:[/?#:]|$)/,
        propagatorTypes: ['tracecontext', 'datadog'],
      },
    ],
    traceSampleRate: window._env_.DATADOG_TRACE_SAMPLE_RATE ? Number(window._env_.DATADOG_TRACE_SAMPLE_RATE) : 100,
    beforeSend: (event) => {
      // Filter out CefSharp email scanner errors
      // These are generated by email security scanners (e.g., Outlook Safe Links)
      // that pre-check URLs with an embedded browser that has known bugs
      // See: https://github.com/DataDog/browser-sdk/issues/2715
      if (event.type === 'error' && (event as RumErrorEvent).error) {
        const error = (event as RumErrorEvent).error;
        const cefSharpErrorPattern = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
        if (error.message && typeof error.message === 'string' && cefSharpErrorPattern.test(error.message)) {
          return false;
        }
      }

      return true;
    },
  });
};
